import { useQuery } from '@tanstack/react-query';
import { listAllOrganisations } from '@/lib/organisations.ts';

/* Under the `organisations` key, so creating or deleting one refreshes the header picker too. */
export function useAllOrganisations(enabled: boolean) {
  return useQuery({
    queryKey: ['organisations', 'all'],
    queryFn: listAllOrganisations,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
